/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CaretCircleDoubleLeft(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M201.53906,54.46094a103.95314,103.95314,0,1,0,0,147.07812A104.12262,104.12262,0,0,0,201.53906,54.46094Zm-83.88281,99.88281a7.99915,7.99915,0,1,1-11.3125,11.3125l-32-32a7.99708,7.99708,0,0,1,0-11.3125l32-32a7.99915,7.99915,0,0,1,11.3125,11.3125L91.3125,128Zm56,0a7.99915,7.99915,0,1,1-11.3125,11.3125l-32-32a7.99708,7.99708,0,0,1,0-11.3125l32-32a7.99915,7.99915,0,0,1,11.3125,11.3125L147.3125,128Z" />
    </Svg>
  );
}

export default CaretCircleDoubleLeft;
